import React__default from 'react';
import { LoaderScreen, Alert } from '@grandvisionhq/common';
import { useConfiguratorContext } from '@grandvisionhq/configurator';
import { useDispatch, useSelector, statusSuccess, useIntl } from '@grandvisionhq/state';
import { VariantSelectionStep } from '../components/VariantSelectionStep/VariantSelectionStep.js';
import { getSelectedFrame, getAddOns, getSelectedAddOn } from '../../../state/configurator/selectors.js';
import { selectAddOn } from '../../../state/configurations/actions.js';

const LensAddOnVariantStepContainer = ()=>{
    const dispatch = useDispatch();
    const { goToNextStep  } = useConfiguratorContext();
    const frame = useSelector(getSelectedFrame);
    const addOns = useSelector(getAddOns);
    const selectedLensAddOn = useSelector(getSelectedAddOn);
    const onChange = React__default.useCallback((sku)=>{
        if (!frame) {
            return;
        }
        dispatch(selectAddOn({
            frameSku: frame.sku,
            addOnSku: sku,
            reason: 'user selection'
        }));
    }, [
        dispatch,
        frame
    ]);
    const variantsList = selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.variants;
    if (!statusSuccess(addOns)) {
        return /*#__PURE__*/ React__default.createElement(LoaderScreen, null);
    }
    if (!variantsList || variantsList.length === 0) {
        return /*#__PURE__*/ React__default.createElement(Failed, null);
    }
    return /*#__PURE__*/ React__default.createElement(VariantSelectionStep, {
        onChange: onChange,
        onSubmit: goToNextStep,
        itemsList: variantsList,
        selectedItemSku: selectedLensAddOn === null || selectedLensAddOn === void 0 ? void 0 : selectedLensAddOn.sku
    });
};
function Failed() {
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Alert, {
        type: "error",
        title: getLabel('products.glasses.configurator.error'),
        className: "variant-selection-step__alert"
    });
}

export { LensAddOnVariantStepContainer };
//# sourceMappingURL=LensAddOnVariantStepContainer.js.map
